// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as DashboardPortalIndexRouteImport } from './routes/_dashboard/portal/index'
import { Route as DashboardDesignerIndexRouteImport } from './routes/_dashboard/designer/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/_dashboard/admin/index'
import { Route as DashboardDesignerPagesRouteImport } from './routes/_dashboard/designer/pages'
import { Route as DashboardAdminUsersRouteImport } from './routes/_dashboard/admin/users'
import { Route as DashboardPortalInvoicesIndexRouteImport } from './routes/_dashboard/portal/invoices/index'
import { Route as DashboardAdminSettingsIndexRouteImport } from './routes/_dashboard/admin/settings/index'
import { Route as DashboardPortalProjectsIdRouteImport } from './routes/_dashboard/portal/projects.$id'
import { Route as DashboardPortalInvoicesIdRouteImport } from './routes/_dashboard/portal/invoices/$id'
import { Route as DashboardDesignerEditorPageIdRouteImport } from './routes/_dashboard/designer/editor.$pageId'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/_dashboard',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const DashboardPortalIndexRoute = DashboardPortalIndexRouteImport.update({
            id: '/portal/',path: '/portal/',getParentRoute: () => DashboardRoute
          })
const DashboardDesignerIndexRoute = DashboardDesignerIndexRouteImport.update({
            id: '/designer/',path: '/designer/',getParentRoute: () => DashboardRoute
          })
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => DashboardRoute
          })
const DashboardDesignerPagesRoute = DashboardDesignerPagesRouteImport.update({
            id: '/designer/pages',path: '/designer/pages',getParentRoute: () => DashboardRoute
          })
const DashboardAdminUsersRoute = DashboardAdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => DashboardRoute
          })
const DashboardPortalInvoicesIndexRoute = DashboardPortalInvoicesIndexRouteImport.update({
            id: '/portal/invoices/',path: '/portal/invoices/',getParentRoute: () => DashboardRoute
          })
const DashboardAdminSettingsIndexRoute = DashboardAdminSettingsIndexRouteImport.update({
            id: '/admin/settings/',path: '/admin/settings/',getParentRoute: () => DashboardRoute
          })
const DashboardPortalProjectsIdRoute = DashboardPortalProjectsIdRouteImport.update({
            id: '/portal/projects/$id',path: '/portal/projects/$id',getParentRoute: () => DashboardRoute
          })
const DashboardPortalInvoicesIdRoute = DashboardPortalInvoicesIdRouteImport.update({
            id: '/portal/invoices/$id',path: '/portal/invoices/$id',getParentRoute: () => DashboardRoute
          })
const DashboardDesignerEditorPageIdRoute = DashboardDesignerEditorPageIdRouteImport.update({
            id: '/designer/editor/$pageId',path: '/designer/editor/$pageId',getParentRoute: () => DashboardRoute
          })





const DashboardRouteChildren = {
  DashboardAdminUsersRoute: DashboardAdminUsersRoute,DashboardDesignerPagesRoute: DashboardDesignerPagesRoute,DashboardAdminIndexRoute: DashboardAdminIndexRoute,DashboardDesignerIndexRoute: DashboardDesignerIndexRoute,DashboardPortalIndexRoute: DashboardPortalIndexRoute,DashboardDesignerEditorPageIdRoute: DashboardDesignerEditorPageIdRoute,DashboardPortalInvoicesIdRoute: DashboardPortalInvoicesIdRoute,DashboardPortalProjectsIdRoute: DashboardPortalProjectsIdRoute,DashboardAdminSettingsIndexRoute: DashboardAdminSettingsIndexRoute,DashboardPortalInvoicesIndexRoute: DashboardPortalInvoicesIndexRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DashboardRoute: DashboardRouteWithChildren,ContactRoute: ContactRoute,LoginRoute: LoginRoute,PortfolioRoute: PortfolioRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,PSlugRoute: PSlugRoute,AboutIndexRoute: AboutIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)